import { connect } from 'react-redux';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { WixConnect } from 'shared/utils/wix-connect';

import { getCurrency } from 'shared/selectors/vod-settings';

import dealInfoShape from 'shared/shapes/deal-info';

import styles from './deal-info.styl';

import sharedTranslations from 'shared/translations';


@connect(state => ({
  defaultCurrency: getCurrency(state),
}))
@WixConnect(styles)
export default class DealInfo extends React.Component {

  static propTypes = {
    defaultCurrency: React.PropTypes.string,
    isMemberOnly: React.PropTypes.bool,
    dealInfo: dealInfoShape,
    className: React.PropTypes.string,
  };

  get freeDealInfo() {
    const { isMemberOnly } = this.props;

    if (isMemberOnly) {
      return (
        <FormattedMessage {...sharedTranslations.memberOnly} />
      );
    }
    return (
      <FormattedMessage {...sharedTranslations.free} />
    );
  }

  get paidDealInfo() {
    const { defaultCurrency } = this.props;
    const { dealInfo } = this.props;
    const formattedDealInfo = _.keyBy(dealInfo, 'type');

    return _.map(dealInfo, function ({ type }) {
      const {
        price,
        enabled,
        currency = defaultCurrency,
      } = formattedDealInfo[type];

      if (!enabled || type === 'member-only') {
        return null;
      }

      const values = {
        price: <FormattedNumber value={price}
                                style="currency"
                                currency={currency} />,
      };

      return (
        <span key={type}
              styleName="info">
          <FormattedMessage {...sharedTranslations[`${type}WithPrice`]}
                            values={values} />
        </span>
      );
    });
  }

  render() {
    const { dealInfo, className } = this.props;

    const isFree = dealInfo.length === 0 || !_.find(dealInfo, { enabled: true });

    const orderedDealInfo = isFree ? this.freeDealInfo : this.paidDealInfo;

    return (
      <span styleName="deal-info"
            className={className}>
        {orderedDealInfo}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/deal-info/deal-info.js